import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { AgapHero, AgapAbout, AgapTrack } from "@/components/agap/AgapInfo";
import { AgapCategories } from "@/components/agap/AgapCategories";
import { AgapRegister } from "@/components/agap/AgapRegister";

export default function Agap() {
  const [data, setData] = useState(null);
  const [params] = useSearchParams();

  useEffect(() => {
    api.get("/agap").then((r) => setData(r.data)).catch(() => setData(false));
    if (params.get("registration") === "cancelled") toast("Payment cancelled. You were not charged.");
  }, [params]);

  if (data === false) return <div className="max-w-7xl mx-auto px-5 py-24 text-[#575757]" data-testid="agap-error">We couldn't load the AGAP page. Please refresh, or email admin@africabrewbrief.com.</div>;
  if (!data) return <div className="max-w-7xl mx-auto px-5 py-24 overline text-[#575757]" data-testid="agap-loading">Loading AGAP…</div>;
  return (
    <div data-testid="agap-page">
      <AgapHero />
      <AgapAbout />
      <AgapTrack />
      <AgapCategories data={data} />
      <AgapRegister data={data} />
      <section className="max-w-7xl mx-auto px-5 py-12 text-sm text-[#575757] flex flex-wrap gap-x-10 gap-y-2" data-testid="agap-contact">
        <span><b className="text-[#0A0A0A]">Event marketing & registration:</b> Africa Brew Brief · <a href="mailto:admin@africabrewbrief.com" className="text-[#4C7A18] underline">admin@africabrewbrief.com</a></span>
        <span><b className="text-[#0A0A0A]">Group:</b> africaonegroup.co</span>
      </section>
    </div>
  );
}
